import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { store } from "./store";
import App from "./App";
import "./i18n/i18n";
import "./style.css";
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import indexedDbStorage from "./store/indexedDbStorage.js"; // ✅
import { markRehydrated } from "./sync/syncService"; // ✅

// serviceWorkerRegistration.register();
serviceWorkerRegistration.register({
  onUpdate: (registration) => {
    if (registration.waiting) {
      registration.waiting.postMessage({ type: 'SKIP_WAITING' });
    }
    window.location.reload();
  }
});

async function bootstrap() {
  const token = localStorage.getItem("token");
  window.__store = store;

  if (token) {
    try {
      const snapshot = await indexedDbStorage.loadSnapshot();
      if (snapshot) {
        store.dispatch({ type: "app/rehydrate", payload: snapshot });
        console.log("💾 Rehydrated from IndexedDB");
      }
    } catch (err) {
      console.warn("IDB rehydration failed", err);
    }
  }

  markRehydrated(); // ✅ store is ready, allow IDB + Mongo writes

  const root = ReactDOM.createRoot(document.getElementById("root"));
  root.render(
    <Provider store={store}>
      <App />
    </Provider>
  );
}

bootstrap();

// ✅ Add this at the bottom
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.addEventListener('controllerchange', () => {
      window.location.reload();
    });
  });
}